export enum CategoryType {
  Product = 0,
  Work = 1,
  Service = 2
}